<template>
  <div class="home">
    <!-- 顶部状态栏 -->
    <!--    <div class="status-bar">
          <div class="status-icons">
            <i class="signal"></i>
            <i class="wifi"></i>
            <i class="battery"></i>
          </div>
        </div>-->

    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">零碳旅呈，携手同行</h1>
        <p class="subtitle">ZERO CARBON TRAVEL PRESENTS WALKING HAND IN HAND</p>
      </div>
      <img class="banner-img" src="../assets/images/wechat.png" alt="banner">
    </div>

    <!-- 微信添加区域 -->
    <div class="card wechat-section" v-if="existWechatChannel">

      <div class="title-container">
        <span class="section-title">添加门店微信</span>
      </div>
      <div style="margin-top: 16px;" class="wechat-button" @click="handleAddWechat">
        <div class="wechat-button-top">
          <img class="wechat-icon"
               src="../assets/images/message.png"
               alt="微信">
          <span class="wechat-font">点击此处添加微信</span>
        </div>
        <div class="service-hint wechat-button-bottom">
          <img alt="" src="../assets/images/gantanhao2.png"/>
          <span class="hint-text">添加企业微信，可联系前台，开票、连wifi等</span>
        </div>
      </div>
    </div>

    <!-- 社交媒体区域 -->
    <div class="card social-section">
      <div class="title-container">
        <span class="section-title" v-if="title">{{ title }}</span>
        <span class="section-title" v-else>查看更多酒店信息、开发票、连wifi等</span>
      </div>
      <div style="margin-top: 16px;" class="social-list" :class="{'two-items': validSocialPlatforms.length === 2}">
        <div
          v-for="item in socialPlatforms"
          v-show="item.isShow"
          :key="item.id"
          class="social-item"
          @click="handleSocialClick(item)"
        >
          <img :src="item.icon" :alt="item.name">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonApi } from '@/api'

export default {
  name: 'HomePage',
  data () {
    return {
      socialPlatforms: [
        // {
        //   id: 1,
        //   name: '抖音',
        //   icon: require('@/assets/images/douyin.png'),
        //   isShow: true
        // },
        // {
        //   id: 2,
        //   name: 'App',
        //   icon: require('@/assets/images/app.png'),
        //   isShow: true
        // }
      ],
      validSocialPlatforms: [],
      dyMerchantId: '',
      jumpPage: false,
      existWechatChannel: false,
      title: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    handleAddWechat () {
      const urlParams = new URLSearchParams(window.location.search)
      let query = 'nfcConfig=' + urlParams.get('nfcConfig')
      if (urlParams.get('jump')) {
        query += '&jump=1'
      }
      query = encodeURIComponent(query)
      window.location.href = 'weixin://dl/business/?appid=wx5df1f30bff9f5005&path=pages/add-contact/add-contact&query=' + query
    },
    handleSocialClick (platform) {
      if (platform.id === 1) {
        window.location.href = 'snssdk1128://poi/detail?id=' + platform.merchantId + '&&from=webview&refer=web'
      }
      if (platform.id === 2 || platform.id === 4 || platform.id === 3) {
        if (!platform.jumpUrl.startsWith('http://') && !platform.jumpUrl.startsWith('https://')) {
          platform.jumpUrl = 'http://' + platform.jumpUrl
        }
        window.location.href = platform.jumpUrl
      }
    },
    async init () {
      try {
        // 从地址上获取 问号后面的参数id
        const urlParams = new URLSearchParams(window.location.search)
        this.jumpPage = urlParams.get('jump')?.toString() === '1'
        // eslint-disable-next-line camelcase
        const request_data = {
          id: urlParams.get('nfcConfig'),
          webApplyChannel: this.jumpPage ? 1 : 0
        }
        if (this.jumpPage) {
          await commonApi.recordOpenTimes({
            merchantId: urlParams.get('nfcConfig'),
            type: 0
          })
        } else {
          await commonApi.recordOpenTimes({
            merchantId: urlParams.get('nfcConfig'),
            type: 1
          })
        }
        const result = await commonApi.getNfcConfigItem(request_data)
        if (result.applyChannelList.length > 0) {
          const existChannel = {}
          for (let i = 0; i < result.applyChannelList.length; i++) {
            existChannel[result.applyChannelList[i]] = 1
          }
          const order = [4, 1, 3, 2]

          const channelConfig = result.channelConfig
          for (let k = 0; k < channelConfig.length; k++) {
            if (channelConfig[k].isShow === 0) continue
            const contentJson = JSON.parse(channelConfig[k].contentJson)
            if (channelConfig[k].channelId === 0) {
              this.existWechatChannel = true
              continue
            }
            this.socialPlatforms.push({
              id: channelConfig[k].channelId,
              name: channelConfig[k].channelName,
              icon: 'data:image/xxx;base64,' + contentJson.logo,
              isShow: true,
              jumpUrl: contentJson.jumpUrl,
              merchantId: contentJson.merchantId ? contentJson.merchantId : ''
            })
          }
          this.socialPlatforms = this.socialPlatforms.sort((a, b) => {
            const indexA = order.indexOf(a.id)
            const indexB = order.indexOf(b.id)
            return indexA - indexB
          })
          for (let j = 0; j < this.socialPlatforms.length; j++) {
            if (existChannel[this.socialPlatforms[j].id]) {
              this.socialPlatforms[j].isShow = true
              if (this.jumpPage && (this.socialPlatforms[j].id !== 4 && this.socialPlatforms[j].id !== 3)) {
                this.socialPlatforms[j].isShow = false
              } else {
                this.validSocialPlatforms.push(this.socialPlatforms[j])
              }
            }
          }
        }
        this.title = result.channelTitle
      } catch (error) {
        console.error('无效地址:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.home {
  height: 100%;
  //overflow-y: auto; /* 仅在容器内允许滚动 */
  overflow: hidden;
  -webkit-overflow-scrolling: touch; /* 启用弹性滚动 */
}

.home {
  min-height: 100vh;
  background-color: white;
}

.status-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white;
  z-index: 100;
}

.banner {
  position: relative;

  .banner-content {
    position: absolute;
    top: 44px; // 状态栏高度
    left: 26px; // 左边距26px
    z-index: 2;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: $white;
      margin-bottom: 4px;
    }

    .subtitle {
      font-size: 12px;
      color: rgba($white, 0.8);
      max-width: 209px; // 设置最大宽度
      line-height: 1.4; // 适当的行高
      word-wrap: break-word; // 确保长单词也会换行
      text-transform: uppercase; // 确保全大写
    }
  }

  .banner-img {
    width: 100%;
    display: block;
  }
}

.card {
  padding: 16px;
  background: $white;
  border-radius: $border-radius-large;
  position: relative;

  .title-container {
    position: relative;
    background: transparent; /* 关键：确保父容器背景透明 */
    margin-bottom: 16px;
  }

  .title-container::before {
    content: "";
    position: absolute;
    left: 12%;
    bottom: 0;
    transform: translateX(-50%); /* 水平居中 */
    width: 260px; /* 根据实际图片宽度调整 */
    height: 12px; /* 根据实际图片高度调整 */
    background: url(../assets/images/title_bg_2x.png) no-repeat center; /* 替换为你的背景图路径 */
    background-size: contain; /* 保持图片比例 */
    z-index: 0; /* 调整为0 */
  }

  .section-title {
    font-size: $font-size-xlarge;
    color: $text-color;
    position: relative;
    z-index: 1; /* 提升文字层级 */
    font-weight: bold;
  }
}

.wechat-section {
  .wechat-button {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 10px; // 调整内边距
    background-image: url("@/assets/images/wechat_bg_all.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    height: 140px;
    display: flex;
    color: $white;

    .wechat-button-top {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 30px;

      .wechat-icon {
        width: 44px;
        height: 45px;
        margin-right: 6px;
        display: block; // 确保图标正确显示
        flex-shrink: 0; // 防止图标被压缩
        //margin-left: 81px;
      }

      .wechat-font {
        font-size: 20px;
        font-weight: bold;
        color: #37838C;
        line-height: 20px;
        display: inline-block;
      }
    }

    .service-hint {
      width: 100%;
      position: absolute;
      bottom: 28px;
      left: 28px;
      display: flex;
      margin-top: 50px;

      img {
        width: 15px;
        height: 15px;
      }

      .hint-text {
        margin-left: 3px;
        color: rgba(56, 159, 171, 1);
        font-size: 12px;
      }
    }
  }
}

.social-section {
  .social-list {
    display: flex;
    flex-wrap: wrap; // 支持多行展示
    //justify-content: space-between;
    padding: 0 20px;
    gap: 20px; // 设置行与行之间的间距

    // 当只有两个元素时的特殊样式
    //&.two-items {
    //  justify-content: center; // 居中对齐
    //  gap: 10px !important; // 强制设置两个元素之间的间距
    //}
  }

  .social-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: calc(33.33% - 15px); // 每行最多显示3个元素
    box-sizing: border-box;

    img {
      width: 88px;
      height: 88px;
      border-radius: $border-radius-base;
    }

    span {
      font-size: $font-size-base;
      color: $text-color;
      font-weight: bold;
    }
  }
}
</style>
